export default __webpack_public_path__ + "static/media/BrainlabNowW05-Medium.c3b647d4.woff";